import React from "react";
import { Helmet } from "react-helmet";

export const SITE_URL = "https://www.fo.newvgroup.com";
export const ORG_NAME = "New Vision Family Office";
export const ORG_NAME_CN = "新愿景家族办公室";

interface SchemaMarkupProps {
  data: Record<string, any> | Record<string, any>[];
}

export default function SchemaMarkup({ data }: SchemaMarkupProps) {
  const schemas = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {schemas.map((schema, i) => (
        <script key={`ld-json-${i}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: ORG_NAME,
    alternateName: ["NVFO", ORG_NAME_CN],
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description:
      `新愿景家族办公室（New Vision Family Office），秉承\u201c洞悉时局变迁，专业规划配置，稳定增值传延\u201d的理念，为中国超高净值家族提供一站式全球资产配置、身份和教育规划、财富管理传承和私人银行等服务。`,
    legalName: "New Vision International Group Limited",
    address: {
      "@type": "PostalAddress",
      streetAddress: "16 Berkeley Street, Mayfair",
      addressLocality: "London",
      postalCode: "W1J 8DZ",
      addressCountry: "GB",
    },
    telephone: "+442039074025",
    email: "fo@newvgroup.com",
    areaServed: "Worldwide",
    knowsLanguage: ["zh", "en"],
  };
}

export function webSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: ORG_NAME,
    alternateName: ORG_NAME_CN,
    url: SITE_URL,
  };
}

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function webPageSchema(opts: {
  name: string;
  description: string;
  path: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: opts.name,
    description: opts.description,
    url: `${SITE_URL}${opts.path}`,
    isPartOf: {
      "@type": "WebSite",
      url: SITE_URL,
      name: ORG_NAME,
    },
  };
}

export function serviceSchema(opts: {
  name: string;
  description: string;
  path: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: opts.name,
    description: opts.description,
    url: `${SITE_URL}${opts.path}`,
    provider: {
      "@type": "Organization",
      name: ORG_NAME,
      url: SITE_URL,
    },
    areaServed: "Worldwide",
  };
}

export function faqSchema(items: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}
